export { ParentHomePage } from "./ParentHomePage"
export type { ParentHomePageProps } from "./ParentHomePage"
